import { render, staticRenderFns } from "./RsvpPageLanguageSelector.vue?vue&type=template&id=0054c3d3"
import script from "./RsvpPageLanguageSelector.vue?vue&type=script&lang=js"
export * from "./RsvpPageLanguageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports